import { useEffect } from "react";
import api from "../apis";
import Cookies from "universal-cookie";
import { getRemainingSecondsTillMidnight, getSubsCookiesInfo } from "./helper";
import TwistSettings from "../TwistSettings.json";

export default function useSubscriptionCookieValidator() {
  const services = [
    "local",
    "international",
    "africa",
    "othersports",
    "fitness",
    "meloukelkora",
  ];
  const cookies = new Cookies();
  const maxAge = getRemainingSecondsTillMidnight();

  useEffect(() => {
    if (TwistSettings["subscription"]) {
      const { msisdns } = getSubsCookiesInfo();
      services.forEach((serviceName) => {
        msisdns.forEach((msisdn) => {
          api.subscription[serviceName]
            ?.checkSubsByMsisdn(msisdn)
            .then((res) => {
              if (res.status === 1) {
                if (
                  serviceName === "meloukelkora" ||
                  serviceName === "africa"
                ) {
                  ["meloukelkora", "africa"].map((ele) =>
                    cookies.set(`${ele}`, `wifi,${msisdn}`, {
                      path: "/",
                      maxAge,
                    }),
                  );
                } else {
                  cookies.set(`${serviceName}`, `wifi,${msisdn}`, {
                    path: "/",
                    maxAge,
                  });
                }
              } else {
                // Just For Test 10 Jan
                // cookies.remove(serviceName, { path: '/', domain: window.location.hostname })
              }
            });
        });
      });
    }
  }, []);

  return null;
}
